// Penanda kapan terakhir ada perubahan data (simpan/ubah/hapus) di sesi ini.
// Dipakai summary ber-cache (cache=1) supaya request pertama setelah ada perubahan
// langsung kirim force_refresh=1, karena cache summary di BE tidak terhapus oleh transaksi.
let lastDataChangedAt = 0

const MUTATION_METHODS = ['post', 'put', 'patch', 'delete']

// Endpoint yang bisa mengubah angka summary (transaksi, produk, kontak, kasir, bank, marketplace).
// Pengaturan (/options, /finance/options/*) tidak mengubah angka summary.
const DATA_URL_PATTERN = /(^|\/)(finance|pos|bankTrans|marketplaceConnects)\//
const IGNORED_URL_PATTERN = /(^|\/)finance\/options\//

// TTL cache summary di BE. Lewat dari ini, cache yang dibuat sebelum perubahan sudah kedaluwarsa
// sendiri, jadi tidak perlu dipaksa force_refresh lagi.
const SUMMARY_CACHE_TTL = 15 * 60 * 1000

// Lama summary dianggap segar di browser: pindah halaman lalu kembali dalam rentang ini
// tidak hit summary lagi (kecuali ada perubahan data, lihat refreshIfChanged di useReportQuery).
export const SUMMARY_STALE_TIME = 5 * 60 * 1000

export const markDataChangedFromResponse = (response) => {
  const { method, url = '' } = response?.config || {}
  if (
    MUTATION_METHODS.includes(method) &&
    DATA_URL_PATTERN.test(url) &&
    !IGNORED_URL_PATTERN.test(url)
  ) {
    lastDataChangedAt = Date.now()
  }
}

// true kalau ada perubahan data setelah lastFetchedAt dan cache BE mungkin masih menyimpan
// angka sebelum perubahan itu.
export const isDataChangedSince = (lastFetchedAt = 0) =>
  lastDataChangedAt > lastFetchedAt && Date.now() - lastDataChangedAt < SUMMARY_CACHE_TTL

// Summary gagal dimuat: request error tanpa data lama, atau respons tanpa isi data
// (mis. BE membalas 200 tanpa `data`). Kotak jangan menampilkan 0 palsu untuk kondisi ini.
export const isSummaryLoadFailed = ({ data, isError }) =>
  (isError && !data) || (!!data && Object.keys(data).every((key) => key === '_cache_meta'))
